<!-- SelectSortOrderFilter.vue -->
<!--
  Mini-modal de ordenação da lista de notas. Mesmo molde do SelectPeriodFilter:
  abre a partir de uma linha do NoteFilter.

  São três ordens EXCLUSIVAS, não caixas independentes — uma lista só pode estar
  numa ordem de cada vez. E o clique numa opção já aplica: diferente do período,
  onde há campos a preencher antes de a escolha fazer sentido, aqui o clique é a
  escolha inteira, e um botão de confirmar seria um passo sem conteúdo.

  "Ordem do texto" é a ordem dos expoentes que o leitor mostra. O número do
  expoente não é gravado em lugar nenhum: os renderizadores o calculam ordenando
  as notas por `textRangeStart` crescente e numerando a partir de 1 — a regra
  vive em `utils/noteOrdering.js`, compartilhada com a store e espelhada no
  backend.

  Props:
    isOpen     — controla visibilidade
    modelValue — "textOrder" | "newest" | "oldest"

  Emits:
    update:modelValue — nova ordem
    apply             — a escolha foi feita; o NoteFilter refaz a busca
    close
-->
<script setup>
import AnchoredPanel from "@/components/Generics/AnchoredPanel.vue";
defineProps({
  isOpen: { type: Boolean, default: false },
  modelValue: { type: String, default: "textOrder" },
});

const emit = defineEmits(["update:modelValue", "apply", "close"]);

// O rótulo é local; a chave é a mesma que a store guarda e que o backend recebe
// em `sortBy`.
const options = [
  { value: "textOrder", label: "Ordem do texto" },
  { value: "newest", label: "Mais recentes primeiro" },
  { value: "oldest", label: "Mais antigas primeiro" },
];

function selectOrder(value) {
  emit("update:modelValue", value);
  emit("apply");
}
</script>

<template>
  <AnchoredPanel
    :open="isOpen"
    placement="side"
    align="left"
    :gap="8"
    @close="emit('close')"
  >
    <div
      class="sort-filter-container"
      role="dialog"
      aria-label="Ordenar notas"
      @click.stop
      @mousedown.stop
    >
      <div class="body-section">
        <label v-for="option in options" :key="option.value" class="radio-item">
          <input
            type="radio"
            name="note-sort-order"
            class="radio-input"
            :value="option.value"
            :checked="modelValue === option.value"
            @change="selectOrder(option.value)"
          />
          <span class="radio-label">{{ option.label }}</span>
        </label>
      </div>
    </div>
  </AnchoredPanel>
</template>

<style scoped>
.sort-filter-container {
  background-color: var(--surface);
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--border-color);
  width: 230px;
  display: flex;
  flex-direction: column;
}

.body-section {
  padding: 10px 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.radio-input {
  accent-color: var(--brand-light);
  cursor: pointer;
}

.radio-label {
  font-size: 0.82rem;
  color: var(--text-dark);
}
</style>
